import request from './request'

// 删除买量事件
export const deleteBuyEvent = data => request('/buyEvent/delete', data, 'GET')
// 获取买量事件详情
export const getBuyEventDetail = data => request('/buyEvent/detail', data, 'GET')
// 获取买量事件分页列表
export const getBuyEventPageList = data => request('/buyEvent/pageList', data, 'POST_JSON')
// 保存买量事件
export const saveBuyEvent = data => request('/buyEvent/save', data, 'POST_JSON')
// 更新买量事件状态
export const updateBuyEventStatus = data => request('/buyEvent/updateStatus', data, 'GET')
// 获取买量事件枚举
export const getBuyEventEnumAll = () => request('/buyEvent/enum/all', null, 'GET')

// 保存买量事件草稿
export const saveBuyEventDraft = data => request('/buyEvent/saveDraft', data, 'POST_JSON')

// 获取买量事件草稿
export const getBuyEventDraft = () => request('/buyEvent/getDraft', null, 'GET')

// 删除买量事件草稿
export const deleteBuyEventDraft = () => request('/buyEvent/deleteDraft', null, 'POST_JSON')
